module.exports = __webpack_public_path__ + "static/media/logo.027dc2c1.svg";